<span class="custom-snackbar" matSnackBarLabel>
    <h4>{{data.title}}</h4>
    <p>{{data.text}}</p>
</span>
<span class="custom-snackbar-actions" matSnackBarActions>
    <button mat-button class="custom-snack-button" matSnackBarAction (click)="snackBarRef.dismissWithAction()">OK</button>
  </span>
